import React, { useEffect, useState, useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import CloseIcon from '@material-ui/icons/Close';
import ModeContext from '../../../context/ModeContext';

import { useTranslation } from 'react-i18next';

import {
  WaterLevelBlueIcon,
  WaterLevelBrownIcon,
  WaterLevelGreenIcon,
  WaterLevelRedIcon,
  WaterLevelYellowIcon,
} from '../../../assets/svg/Icon';

import { styles } from './style';

const useStyles = makeStyles(styles);
export default function WaterLevelDatalists() {
  const { t } = useTranslation();
  const hostApi = `${process.env.REACT_APP_API_URL}`;
  const { currentSelectList } = useContext(ModeContext);
  const [totalWlStation, settotalWlStation] = useState({
    total: 0,
    range_100: 0,
    range_70: 0,
    range_30: 0,
    range_10: 0,
    rangeless_10: 0,
    nodata: 0,
  });

  useEffect(() => {
    function getData() {
      fetch(`${hostApi}/provinces/waterlevel?province_code=${currentSelectList}`)
        .then((response) => {
          if (response.ok) {
            return response.json();
          }
          throw new Error('Something went wrong ...');
        })
        .then((result) => {
          // console.log(result);
          // filter null and data not updated in 24 hrs
          let filterDatas = [];
          const currentDateTime = new Date();
          const last24hrs = currentDateTime.setDate(currentDateTime.getDate() - 1);

          if (result.data.length > 0) {
            filterDatas = result.data.filter((d) => {
              const time = new Date(d.waterlevel_datetime.replace(/-/g, '/')).getTime();
              return (last24hrs < time && d.waterlevel_msl != null);
            });
          }

          const totalWlStationtemp = {
            total: filterDatas.length,
            range_100: 0,
            range_70: 0,
            range_30: 0,
            range_10: 0,
            rangeless_10: 0,
            nodata: 0,
          };

          for (const s of filterDatas) {
            if (s.storage_percent === null) {
              totalWlStationtemp.nodata += 1;
            } else if (s.storage_percent > 100) {
              totalWlStationtemp.range_100 += 1;
            } else if (s.storage_percent > 70) {
              totalWlStationtemp.range_70 += 1;
            } else if (s.storage_percent > 30) {
              totalWlStationtemp.range_30 += 1;
            } else if (s.storage_percent > 10) {
              totalWlStationtemp.range_10 += 1;
            } else if (s.storage_percent <= 10) {
              totalWlStationtemp.rangeless_10 += 1;
            }
          }
          // console.log(totalWlStationtemp);
          settotalWlStation(totalWlStationtemp);
        })
        .catch((error) => (console.log(error)));
    }
    getData();
  }, [hostApi, currentSelectList]);

  const classes = useStyles();

  return (
    <>
      <Box p={2} className={classes.boxContent}>
        <Grid container spacing={0} justifyContent="center">
          <Grid item xs={7}>
            <Box display="flex" alignItems="center">
              <Box p={1} className={classes.title} alignItems="center">{t('สถานีวัดระดับน้ำ')}</Box>
            </Box>
          </Grid>
          <Grid item xs={5} id="totol_station">
            <Box display="flex" alignItems="center">
              <Box display="flex" className={`${classes.shapeAllCircle} ${classes.colorAll}`} alignItems="center" justifyContent="center">{totalWlStation.total}</Box>
              <Box p={1} className={classes.unitAll}>{t('สถานี')}</Box>
            </Box>
          </Grid>
          <Grid item xs={8}>
            <Box display="flex" alignItems="center">
              <Box display="flex" alignItems="center" justifyContent="center">
                <WaterLevelRedIcon className={classes.icon} />
              </Box>
              <Box p={1} className={classes.status}>{t('น้ำล้นตลิ่ง')}</Box>
            </Box>
          </Grid>
          <Grid item xs={4} id="station_range_100">
            <Box display="flex" alignItems="center">
              <Box display="flex" className={`${classes.shapeCircle} ${classes.five}`} alignItems="center" justifyContent="center">{totalWlStation.range_100}</Box>
              <Box p={1} className={classes.unit}>{t('สถานี')}</Box>
            </Box>
          </Grid>
          <Grid item xs={8}>
            <Box display="flex" alignItems="center">
              <Box display="flex" alignItems="center" justifyContent="center">
                <WaterLevelBlueIcon className={classes.icon} />
              </Box>
              <Box p={1} className={classes.status}>{t('น้ำมาก')}</Box>
            </Box>
          </Grid>
          <Grid item xs={4} id="station_range_70">
            <Box display="flex" alignItems="center">
              <Box display="flex" className={`${classes.shapeCircle} ${classes.four}`} alignItems="center" justifyContent="center">{totalWlStation.range_70}</Box>
              <Box p={1} className={classes.unit}>{t('สถานี')}</Box>
            </Box>
          </Grid>
          <Grid item xs={8}>
            <Box display="flex" alignItems="center">
              <Box display="flex" alignItems="center" justifyContent="center">
                <WaterLevelGreenIcon className={classes.icon} />
              </Box>
              <Box p={1} className={classes.status}>{t('ปกติ')}</Box>
            </Box>
          </Grid>
          <Grid item xs={4} id="station_range_30">
            <Box display="flex" alignItems="center">
              <Box display="flex" className={`${classes.shapeCircle} ${classes.three}`} alignItems="center" justifyContent="center">{totalWlStation.range_30}</Box>
              <Box p={1} className={classes.unit}>{t('สถานี')}</Box>
            </Box>
          </Grid>
          <Grid item xs={8}>
            <Box display="flex" alignItems="center">
              <Box display="flex" alignItems="center" justifyContent="center">
                <WaterLevelYellowIcon className={classes.icon} />
              </Box>
              <Box p={1} className={classes.status}>{t('น้ำน้อย')}</Box>
            </Box>
          </Grid>
          <Grid item xs={4} id="station_range_10">
            <Box display="flex" alignItems="center">
              <Box display="flex" className={`${classes.shapeCircle} ${classes.two}`} alignItems="center" justifyContent="center">{totalWlStation.range_10}</Box>
              <Box p={1} className={classes.unit}>{t('สถานี')}</Box>
            </Box>
          </Grid>
          <Grid item xs={8}>
            <Box display="flex" alignItems="center">
              <Box display="flex" alignItems="center" justifyContent="center">
                <WaterLevelBrownIcon className={classes.icon} />
              </Box>
              <Box p={1} className={classes.status}>{t('น้ำน้อยวิกฤติ')}</Box>
            </Box>
          </Grid>
          <Grid item xs={4} id="station_range_70_less">
            <Box display="flex" alignItems="center">
              <Box display="flex" className={`${classes.shapeCircle} ${classes.one}`} alignItems="center" justifyContent="center">{totalWlStation.rangeless_10}</Box>
              <Box p={1} className={classes.unit}>{t('สถานี')}</Box>
            </Box>
          </Grid>
          <Grid item xs={8}>
            <Box display="flex" alignItems="center">
              <Box ml={1} display="flex" styel={{ width: '40px' }} className={`${classes.shapeCircle} ${classes.blank}`} alignItems="center" justifyContent="center"><CloseIcon style={{ color: '#fff', fontSize: '14px' }} /></Box>
              <Box ml={2} p={1} className={classes.status}>{t('ไม่มีข้อมูล')}</Box>
            </Box>
          </Grid>
          <Grid item xs={4} id="station_range_nodata">
            <Box display="flex" alignItems="center">
              <Box display="flex" className={`${classes.shapeCircle} ${classes.blank}`} alignItems="center" justifyContent="center">{totalWlStation.nodata}</Box>
              <Box p={1} className={classes.unit}>{t('สถานี')}</Box>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </>
  );
}
